import { useDevice } from '../../store/devices/useDevices';

export function OwnerResolver(props) {
  const [, type, id] = props.ownerUri?.split(':') ?? [null, null, null];

  switch (type) {
    case 'device':
      return <DeviceOwner ownerId={id} children={props.children} />;
    default:
      return props.children({ ownerName: null });
  }
}

function DeviceOwner(props) {
  const { device } = useDevice({ deviceId: props.ownerId });

  return props.children({ ownerName: device?.name ?? null });
}
